import { outlinedInputClasses } from '@mui/material';

import type { Theme } from '@mui/material';

export const muiOutlinedInputOverrides = {
	styleOverrides: {
		root: ({ theme }: { theme: Theme }) => {
			return {
				boxSizing: 'border-box !important',
				[`& .${outlinedInputClasses.input}`]: {
					backgroundColor: theme.palette.background.paper,
					height: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? '36px !important' : '30px !important',
					padding: '4px 10px',
					boxSizing: 'border-box',
					lineHeight: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? '28px !important' : '22px !important',
					'&.MuiInputBase-readOnly': {
						backgroundColor: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'hsla(0, 0%, 85%, 1)' : 'inherit',
						color: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'hsla(0, 0%, 59%, 1) !important' : 'inherit',
					},
				},
				'&:hover': {
					[`& .${outlinedInputClasses.notchedOutline}`]: {
						border: '1px solid hsla(199,100%,50%,.25)',
						boxShadow: '0 0 0 1px hsla(199,100%,50%,.75)',
						borderRadius: theme.shape.borderRadius,
					},
				},
				[`& .${outlinedInputClasses.notchedOutline}`]: {
					width: '100%',
					boxSizing: 'border-box',
					top: 0,
					legend: {
						display: 'none',
					},
				},
			};
		},
	},
};
